export const formatDateToShortString = (isoDateStr) => {
  const date = new Date(isoDateStr);
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}


export const  formatTime = (datetimeStr) => {
  const date = new Date(datetimeStr)
  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12
  return `${hours}:${minutes} ${ampm}`
}


export const compareTimes = (time1, time2) => {
  // Допоміжна функція для конвертації часу в хвилини
  function timeToMinutes(time) {
    let [hourMin, period] = time.split(' ');
    let [hour, minute] = hourMin.split(':').map(Number);

    // Нормалізуємо період до верхнього регістру
    period = period.toUpperCase();

    if (period === 'PM' && hour !== 12) hour += 12;
    if (period === 'AM' && hour === 12) hour = 0;

    return hour * 60 + minute;
  }

  const minutes1 = timeToMinutes(time1);
  const minutes2 = timeToMinutes(time2);

  if (minutes1 >= minutes2) return true;   // time1 більший
  if (minutes1 <= minutes2) return false;  // time2 більший

};